import { createAction } from "@ngrx/store";

export const noOp = createAction('[Global] No Operation');
